// extracted by mini-css-extract-plugin
module.exports = {"header":"NewsDetailContainer_header__2ICQ6","container":"NewsDetailContainer_container__3i1AW"};